﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = exports.PageOrder = exports.PageDriverWork = exports.PageCustomerNewOrder = exports.PageDriver = exports.PageRate = exports.PageRatesArea = exports.PageVehicle = exports.PageCompany = exports.PageVehiclesType = exports.PageProfile = exports.PageCreateProfileByPhone = exports.PageDashboard = exports.PageList = exports.PageLogin = exports.LeftNavBar = exports.TopNavBar = exports.ModalDialog = void 0;
const gs = require("@ivanlog/gs");
class ModalDialogControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.container = this._ctrls.get('container');
        this.content = this._ctrls.get('content');
        this.header = this._ctrls.get('header');
        this.textTitle = this._ctrls.get('textTitle');
        this.btnClose = this._ctrls.get('btnClose');
        this.body = this._ctrls.get('body');
        this.footer = this._ctrls.get('footer');
        this.btnOk = this._ctrls.get('btnOk');
        this.btnNo = this._ctrls.get('btnNo');
        this.btnCancel = this._ctrls.get('btnCancel');
    }
}
class ModalDialog extends gs.ComponentGS {
    constructor() {
        super("modalDialog", ModalDialogControls);
    }
}
exports.ModalDialog = ModalDialog;
class TopNavBarControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.label = this._ctrls.get('label');
    }
}
class TopNavBar extends gs.ComponentGS {
    constructor() {
        super("topNavBar", TopNavBarControls);
    }
}
exports.TopNavBar = TopNavBar;
class LeftNavBarControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.blockCustomer = this._ctrls.get('blockCustomer');
        this.blockDriver = this._ctrls.get('blockDriver');
        this.blockManager = this._ctrls.get('blockManager');
        this.linkLogout = this._ctrls.get('linkLogout');
    }
}
class LeftNavBar extends gs.ComponentGS {
    constructor() {
        super("leftNavBar", LeftNavBarControls);
    }
}
exports.LeftNavBar = LeftNavBar;
class PageLoginControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.formPhone = this._ctrls.get('formPhone');
        this.taPhone = this._ctrls.get('taPhone');
        this.btnSend = this._ctrls.get('btnSend');
        this.formConfirmCode = this._ctrls.get('formConfirmCode');
        this.taCode = this._ctrls.get('taCode');
        this.btnConfirm = this._ctrls.get('btnConfirm');
        this.btnSendAgain = this._ctrls.get('btnSendAgain');
        this.btnCancel = this._ctrls.get('btnCancel');
    }
}
class PageLogin extends gs.ComponentGS {
    constructor() {
        super("pageLogin", PageLoginControls);
    }
}
exports.PageLogin = PageLogin;
class PageListControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.btnNew = this._ctrls.get('btnNew');
        this.blockSearch = this._ctrls.get('blockSearch');
        this.taSearch = this._ctrls.get('taSearch');
        this.btnSearch = this._ctrls.get('btnSearch');
        this.list = this._ctrls.get('list');
    }
}
class PageList extends gs.ComponentGS {
    constructor() {
        super("pageList", PageListControls);
    }
}
exports.PageList = PageList;
class PageDashboardControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.mapContainer = this._ctrls.get('mapContainer');
    }
}
class PageDashboard extends gs.ComponentGS {
    constructor() {
        super("pageDashboard", PageDashboardControls);
    }
}
exports.PageDashboard = PageDashboard;
class PageCreateProfileByPhoneControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.form = this._ctrls.get('form');
        this.btnCreate = this._ctrls.get('btnCreate');
    }
}
class PageCreateProfileByPhone extends gs.ComponentGS {
    constructor() {
        super("pageCreateProfileByPhone", PageCreateProfileByPhoneControls);
    }
}
exports.PageCreateProfileByPhone = PageCreateProfileByPhone;
class PageProfileControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.btnSave = this._ctrls.get('btnSave');
        this.btnDelete = this._ctrls.get('btnDelete');
        this.formUser = this._ctrls.get('formUser');
        this.pAuths = this._ctrls.get('pAuths');
        this.blockAccessControl = this._ctrls.get('blockAccessControl');
        this.listAccesses = this._ctrls.get('listAccesses');
    }
}
class PageProfile extends gs.ComponentGS {
    constructor() {
        super("pageProfile", PageProfileControls);
    }
}
exports.PageProfile = PageProfile;
class PageVehiclesTypeControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.btnSave = this._ctrls.get('btnSave');
        this.form = this._ctrls.get('form');
    }
}
class PageVehiclesType extends gs.ComponentGS {
    constructor() {
        super("pageVehiclesType", PageVehiclesTypeControls);
    }
}
exports.PageVehiclesType = PageVehiclesType;
class PageCompanyControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.btnSave = this._ctrls.get('btnSave');
        this.btnDelete = this._ctrls.get('btnDelete');
        this.form = this._ctrls.get('form');
        this.iName = this._ctrls.get('iName');
        this.iShortName = this._ctrls.get('iShortName');
    }
}
class PageCompany extends gs.ComponentGS {
    constructor() {
        super("pageCompany", PageCompanyControls);
    }
}
exports.PageCompany = PageCompany;
class PageVehicleControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.btnSave = this._ctrls.get('btnSave');
        this.btnDelete = this._ctrls.get('btnDelete');
        this.form = this._ctrls.get('form');
        this.rbType = this._ctrls.get('rbType');
        this.iGovNumber = this._ctrls.get('iGovNumber');
        this.iModel = this._ctrls.get('iModel');
        this.iColor = this._ctrls.get('iColor');
    }
}
class PageVehicle extends gs.ComponentGS {
    constructor() {
        super("pageVehicle", PageVehicleControls);
    }
}
exports.PageVehicle = PageVehicle;
class PageRatesAreaControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.btnSave = this._ctrls.get('btnSave');
        this.form = this._ctrls.get('form');
        this.iName = this._ctrls.get('iName');
        this.btnClear = this._ctrls.get('btnClear');
    }
}
class PageRatesArea extends gs.ComponentGS {
    constructor() {
        super("pageRatesArea", PageRatesAreaControls);
    }
}
exports.PageRatesArea = PageRatesArea;
class PageRateControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.btnSave = this._ctrls.get('btnSave');
        this.btnDelete = this._ctrls.get('btnDelete');
        this.form = this._ctrls.get('form');
        this.rbRatesArea = this._ctrls.get('rbRatesArea');
        this.cbForVehiclesTypes = this._ctrls.get('cbForVehiclesTypes');
    }
}
class PageRate extends gs.ComponentGS {
    constructor() {
        super("pageRate", PageRateControls);
    }
}
exports.PageRate = PageRate;
class PageDriverControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.btnSave = this._ctrls.get('btnSave');
        this.btnDelete = this._ctrls.get('btnDelete');
        this.form = this._ctrls.get('form');
        this.listUsers = this._ctrls.get('listUsers');
        this.btnSelectUser = this._ctrls.get('btnSelectUser');
        this.blockSelectCompany = this._ctrls.get('blockSelectCompany');
        this.listCompanies = this._ctrls.get('listCompanies');
        this.btnSelectCompany = this._ctrls.get('btnSelectCompany');
        this.blockSelectVehicles = this._ctrls.get('blockSelectVehicles');
        this.listVehicles = this._ctrls.get('listVehicles');
        this.btnAddVehicle = this._ctrls.get('btnAddVehicle');
    }
}
class PageDriver extends gs.ComponentGS {
    constructor() {
        super("pageDriver", PageDriverControls);
    }
}
exports.PageDriver = PageDriver;
class PageCustomerNewOrderControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.form = this._ctrls.get('form');
        this.listUsers = this._ctrls.get('listUsers');
        this.btnSelectUser = this._ctrls.get('btnSelectUser');
        this.iFromAddress = this._ctrls.get('iFromAddress');
        this.btnSelectFrom = this._ctrls.get('btnSelectFrom');
        this.iToAddress = this._ctrls.get('iToAddress');
        this.btnSelectTo = this._ctrls.get('btnSelectTo');
        this.iTime = this._ctrls.get('iTime');
        this.rbType = this._ctrls.get('rbType');
        this.cbFlags = this._ctrls.get('cbFlags');
        this.btnCalc = this._ctrls.get('btnCalc');
        this.lOffer = this._ctrls.get('lOffer');
        this.btnConfirm = this._ctrls.get('btnConfirm');
    }
}
class PageCustomerNewOrder extends gs.ComponentGS {
    constructor() {
        super("pageCustomerNewOrder", PageCustomerNewOrderControls);
    }
}
exports.PageCustomerNewOrder = PageCustomerNewOrder;
class PageDriverWorkControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.blockWork = this._ctrls.get('blockWork');
        this.blockStartWork = this._ctrls.get('blockStartWork');
        this.rbVehicles = this._ctrls.get('rbVehicles');
        this.btnStart = this._ctrls.get('btnStart');
        this.btnUpdate = this._ctrls.get('btnUpdate');
        this.btnStop = this._ctrls.get('btnStop');
        this.btnStopPause = this._ctrls.get('btnStopPause');
        this.btnPause = this._ctrls.get('btnPause');
        this.blockOrder = this._ctrls.get('blockOrder');
        this.rbTakedOrders = this._ctrls.get('rbTakedOrders');
        this.lOffer = this._ctrls.get('lOffer');
        this.btnOrderUntake = this._ctrls.get('btnOrderUntake');
        this.btnOrderDriveTo = this._ctrls.get('btnOrderDriveTo');
        this.btnOrderWaitForCustomer = this._ctrls.get('btnOrderWaitForCustomer');
        this.btnOrderWaitLoading = this._ctrls.get('btnOrderWaitLoading');
        this.btnOrderWaitUnloading = this._ctrls.get('btnOrderWaitUnloading');
        this.btnOrdeWaitPay = this._ctrls.get('btnOrdeWaitPay');
        this.btnOrderDriveBy = this._ctrls.get('btnOrderDriveBy');
        this.btnOrderExecute = this._ctrls.get('btnOrderExecute');
    }
}
class PageDriverWork extends gs.ComponentGS {
    constructor() {
        super("pageDriverWork", PageDriverWorkControls);
    }
}
exports.PageDriverWork = PageDriverWork;
class PageOrderControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.lOrderInfo = this._ctrls.get('lOrderInfo');
        this.formChangePrice = this._ctrls.get('formChangePrice');
        this.btnChangePrice = this._ctrls.get('btnChangePrice');
        this.blockControl = this._ctrls.get('blockControl');
        this.btnComplete = this._ctrls.get('btnComplete');
        this.btnCancel = this._ctrls.get('btnCancel');
        this.btnTake = this._ctrls.get('btnTake');
        this.btnUntake = this._ctrls.get('btnUntake');
    }
}
class PageOrder extends gs.ComponentGS {
    constructor() {
        super("pageOrder", PageOrderControls);
    }
}
exports.PageOrder = PageOrder;
class ListItemControls {
    constructor(ctrls) {
        this._ctrls = ctrls;
        this.lId = this._ctrls.get('lId');
        this.lType = this._ctrls.get('lType');
        this.pData = this._ctrls.get('pData');
    }
}
class ListItem extends gs.ComponentGS {
    constructor() {
        super("listItem", ListItemControls);
    }
}
exports.ListItem = ListItem;
gs.WrapperGS.InjectComponents(ModalDialog, 'ModalDialog');
gs.WrapperGS.InjectComponents(TopNavBar, 'TopNavBar');
gs.WrapperGS.InjectComponents(LeftNavBar, 'LeftNavBar');
gs.WrapperGS.InjectComponents(PageLogin, 'PageLogin');
gs.WrapperGS.InjectComponents(PageList, 'PageList');
gs.WrapperGS.InjectComponents(PageDashboard, 'PageDashboard');
gs.WrapperGS.InjectComponents(PageCreateProfileByPhone, 'PageCreateProfileByPhone');
gs.WrapperGS.InjectComponents(PageProfile, 'PageProfile');
gs.WrapperGS.InjectComponents(PageVehiclesType, 'PageVehiclesType');
gs.WrapperGS.InjectComponents(PageCompany, 'PageCompany');
gs.WrapperGS.InjectComponents(PageVehicle, 'PageVehicle');
gs.WrapperGS.InjectComponents(PageRatesArea, 'PageRatesArea');
gs.WrapperGS.InjectComponents(PageRate, 'PageRate');
gs.WrapperGS.InjectComponents(PageDriver, 'PageDriver');
gs.WrapperGS.InjectComponents(PageCustomerNewOrder, 'PageCustomerNewOrder');
gs.WrapperGS.InjectComponents(PageDriverWork, 'PageDriverWork');
gs.WrapperGS.InjectComponents(PageOrder, 'PageOrder');
gs.WrapperGS.InjectComponents(ListItem, 'ListItem');
//# sourceMappingURL=tmpls.js.map